import * as React from 'react'
import {
  Button,
  Link,
  IconButton,
  Typography,
  Box,
  Paper,
  Modal,
  TextField,
  Autocomplete
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DepartmentTable, {
  getDepartmentTableFx
} from '../../components/DepartmentTable'
import axios from 'axios'
import { createEffect, createStore } from 'effector'
import api from '../../Auth/api'
import { useStore } from 'effector-react'
import { useForm } from 'react-hook-form'
import { $userSearch, searchUserFx } from '../../Api/userSearch'
import debounce from 'lodash/debounce'
import { updateModal } from '../../components/ErrorModal'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 2,
  p: 2
}

export default function Departments() {
  const [open, setOpen] = React.useState(false)
  const [department, setDepartment] = React.useState()
  const [responsible, setResponsible] = React.useState()
  const usersTable = useStore($userSearch)
  const handleCloseCreateModal = () => setOpen(false)
  const handleOpenCreateModal = () => {
    setDepartment('')
    setOpen(true)
  }
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm()
  const createDepartmentFx = createEffect(async (value) => {
    api
      .post(`/paid-service/department-create`, value)
      .then(
        () => getDepartmentTableFx(),
        (error) => updateModal(error.response.data.errors)
      )
      .then(() => handleCloseCreateModal())
  })
  const onCreateFormSubmit = () => {
    const data = {
      name: department,
      responsibleUserId: responsible?.id
    }
    createDepartmentFx(data)
  }
  const searchUser = React.useCallback(
    debounce((event, value) => {
      searchUserFx(value)
    }, 200),
    []
  )
  const users = usersTable.map(({ name, id }) => {
    return { title: name, id: id }
  })
  const loading = users.length === 0
  return (
    <>
      <Paper
        sx={{ padding: '1rem', borderRadius: '1rem', mt: 3, maxWidth: '900px' }}
        elevation={0}
      >
        <BlockTitle backUrl="/settings" label="Отделы" />
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <Button sx={{ mb: 2 }} onClick={handleOpenCreateModal}>
            Добавить
          </Button>
          <Modal
            open={open}
            onClose={handleCloseCreateModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <form onSubmit={handleSubmit(onCreateFormSubmit)}>
              <Box sx={style}>
                <Typography
                  mb={3}
                  id="modal-modal-title"
                  variant="h6"
                  fontWeight={600}
                >
                  Отдел
                </Typography>
                <Box display="flex" alignItems="center">
                  <Typography
                    width={150}
                    mb={1}
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    Отдел:
                  </Typography>
                  <Box display="flex" gap={0.5} flexDirection="column">
                    <TextField
                      id="outlined-basic"
                      label="Название"
                      variant="outlined"
                      value={department}
                      sx={{ width: 260 }}
                      {...register('name', { required: true })}
                      onChange={(event) => setDepartment(event.target.value)}
                    />
                    {errors.name && (
                      <span style={{ width: '200px' }}>
                        Поле обязательно для заполнения
                      </span>
                    )}
                  </Box>
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  mt={2}
                >
                  <Typography
                    width={150}
                    mb={1}
                    variant="subtitle1"
                    fontWeight={600}
                  >
                    Ответственный:
                  </Typography>
                  <Box width="260px">
                    <Autocomplete
                      id="tags-standard"
                      options={users}
                      loading={loading}
                      loadingText="Загрузка..."
                      onInputChange={searchUser}
                      onChange={(event, value) => setResponsible(value)}
                      getOptionLabel={(option) => option?.title}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...register('users', { required: true })}
                        />
                      )}
                    />
                    {errors.users && (
                      <span>Поле обязательно для заполнения</span>
                    )}
                  </Box>
                </Box>
                <Box
                  mt={3}
                  width="100%"
                  display="flex"
                  gap={3}
                  justifyContent="flex-end"
                >
                  <Button variant="outlined" onClick={handleCloseCreateModal}>
                    Отмена
                  </Button>
                  <Button type="submit" variant="contained">
                    Сохранить
                  </Button>
                </Box>
              </Box>
            </form>
          </Modal>
          <DepartmentTable />
        </Box>
      </Paper>
    </>
  )
}
